import {isNil, isNotNil} from 'ramda';

import {PermissionExpressionListResponseBody} from '@dms/api/security';
import {Permission} from '@dms/api/shared';
import {isActionPermission} from '@dms/shared';

import {Nullish} from 'shared/web';

export const resolvePermissionAtLeastOne = (
  permissions: Permission[] | Nullish,
  userPermissions: PermissionExpressionListResponseBody | Nullish
) => {
  if (isNil(permissions)) {
    return true;
  }

  if (isNil(userPermissions)) {
    return false;
  }

  const foundPermissions = permissions
    .map((singlePermission) =>
      isActionPermission(singlePermission)
        ? userPermissions?.actions?.find(
            ({actionId, resourceId}) =>
              actionId === singlePermission?.actionId && resourceId === singlePermission?.resourceId
          )
        : userPermissions?.fields?.find(
            ({fieldId, resourceId}) =>
              fieldId === singlePermission?.fieldId && resourceId === singlePermission?.resourceId
          )
    )
    .filter(isNotNil);

  if (foundPermissions.length === 0) {
    return true;
  }

  return foundPermissions.some(
    (singlePermission) => singlePermission.permissionsExpression.result !== 'DISALLOW'
  );
};
